export default __webpack_public_path__ + "static/LeituraTwo-MediumItalic-abef4978921324a2d46a2fca10441a9b.woff";